export default "assets/images/icons/Flèche 02-841d089e.svg";